import { render } from "./ProjectListPage.vue?vue&type=template&id=6f26e672"
import script from "./ProjectListPage.vue?vue&type=script&lang=js"
export * from "./ProjectListPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__